// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__6nogG","item":"Socials_item__ArWvm","link":"Socials_link__yetzh"};